import { environment } from '../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').factory('ClientProfileService', ClientProfileService);

  ClientProfileService.$inject = [
    'RestResource',
    '$translate',
    '$filter',
    'UtilService',
    'ClientProfileModalService',
    'ModalWindowConfirmService',
    'SessionService',
  ];

  function ClientProfileService(
    RestResource,
    $translate,
    $filter,
    UtilService,
    ClientProfileModalService,
    ModalWindowConfirmService,
    SessionService
  ) {
    var utils = new UtilService(this);

    $translate = $filter('translate');

    var apiUrl = environment.apiEndpoint + 'client_profiles';

    var service = {
      getFilterCriteria: getFilterCriteria,
      getClientProfiles: getClientProfiles,
      getClientProfile: getClientProfile,
      saveClientProfile: saveClientProfile,
      deleteClientProfile: deleteClientProfile,
      changeClientProfileStatus: changeClientProfileStatus,
      changeClientProfileDefault: changeClientProfileDefault,
      openClientProfileInfoModal: openClientProfileInfoModal,
    };

    return service;

    ////////////////

    function getFilterCriteria() {
      var filter = {
        page: 1,
        sortDir: 'asc',
        sortedBy: 'name',
      };

      return filter;
    }

    function getClientProfiles(filterCriteria) {
      if (!filterCriteria) {
        filterCriteria = getFilterCriteria();
      }

      filterCriteria.company_id = SessionService.getSelectedAccountCompany().id;

      return RestResource.request(
        'get',
        apiUrl,
        filterCriteria,
        function success(response) {
          response = response.data;

          if (response.meta) {
            return {
              items: response.data,
              meta: utils.getItemsMetaData(response, filterCriteria),
            };
          } else {
            return {
              items: response,
            };
          }
        },
        {}
      );
    }

    function getClientProfile(id) {
      return RestResource.request(
        'get',
        apiUrl + '/' + id,
        {},
        function (response) {
          return response.data;
        },
        function () {
          return false;
        }
      );
    }

    function saveClientProfile(item) {
      let method;
      let url = apiUrl;

      if (!item.id) {
        method = 'post';
        item.company_id = SessionService.getSelectedAccountCompany().id;
      } else {
        method = 'put';
        url = apiUrl + '/' + item.id;
      }

      function success(response) {
        let msg = !item.id ? 'CLIENT_PROFILE_ADDED' : 'CLIENT_PROFILE_MODIFIED';
        utils._successMsg($translate(msg));
        // utils._successMsg($translate.instant(msg));

        return {
          status: true,
          response: response.data,
        };
      }

      function failure(response) {
        return {
          status: false,
          response: response.data,
        };
      }

      return RestResource.request(method, url, { client_profile: item }, success, failure);
    }

    function changeClientProfileStatus(item) {
      utils.changeItemStatus(apiUrl + '/' + item.id, item);
    }

    function deleteClientProfile(item, successCallback) {
      if (item.totalClientsAssigned > 0) {
        var modalParams = {
          mode: 'danger',
          title: 'CANNOT_DELETE_CLIENT_PROFILE',
          body: 'CANNOT_DELETE_CLIENT_PROFILES_WITH_CLIENTS',
        };

        ModalWindowConfirmService.open(modalParams);
        return;
      }

      var params = {
        title: 'DELETE_CLIENT_PROFILE',
        itemName: item.name,
        reason: 'DELETE_ITEM_REASON',
        successMsg: 'CLIENT_PROFILE_DELETED',
      };

      var url = apiUrl + '/' + item.id;
      utils.deleteItem(url, successCallback, params);
    }

    function changeClientProfileDefault(item, getItemsCallback) {
      var url = apiUrl + '/' + item.id;

      item.is_default = true;

      var params = {
        client_profile: {
          is_default: true,
        },
        set_default: true,
      };

      function success() {
        var msg = $translate('DEFAULT_CLIENT_PROFILE_CHANGED');
        utils._successMsg(msg);

        return getItemsCallback();
      }
      function failure() {}

      return RestResource.request('put', url, params, success, failure);
    }

    function openClientProfileInfoModal(clientProfileId) {
      ClientProfileModalService.openClientProfileInfoModal(clientProfileId);
    }
  }
})();
